module.exports = __webpack_public_path__ + "img/72_7.66d43634.png";